<template>
  <div>
    <section class="row introduction">
      <div class="col-sm-8 offset-sm-2 my-4">
        <p class="p-title">{{ $t("rooms.lead.salutation") }}</p>
        <div class="shorter-p-border"></div>
        <p class="p-content">{{ $t("rooms.lead.introduction") }}</p>
      </div>
    </section>
    <section v-if="!loadingRooms">
      <div v-if="errors.length > 0">
        <div
          class="alert alert-danger"
          v-for="(error, index) in errors"
          :key="index"
        >
          <strong>{{ error.message }}:</strong> {{ error.description }}
        </div>
      </div>
      <h3 class="text-center heading heading-title-style" v-else>
        {{ $t("rooms.chooseSeminar") }}:
      </h3>
      <masonry-wall
        class="row room-list"
        :items="rooms"
        :ssr-columns="3"
        :column-width="300"
      >
        <template #default="{ item }">
          <Room :seminar="item" :loadingHashes="loadingHashes"></Room>
        </template>
      </masonry-wall>
    </section>
    <section v-else class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">{{ $t("common.loading") }}...</span>
      </div>
    </section>
  </div>
</template>

<script>
import Room from "../components/Room.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RoomList",
  components: {
    Room,
  },
  data() {
    return {
      errors: [],
      loadingRooms: false,
      loadingHashes: false,
    };
  },
  computed: {
    ...mapGetters(["rooms"]),
  },
  methods: {
    ...mapActions(["fetchRooms", "fetchAndMapHashes"]),
  },
  async mounted() {
    console.log(process.env.VUE_APP_API_URL);
    try {
      this.loadingRooms = true;
      await this.fetchRooms();
    } catch (err) {
      this.errors = [
        ...this.errors,
        { ...err, description: this.$t("rooms.erorMessages.noRooms") },
      ];
    } finally {
      this.loadingRooms = false;
    }
    if (this.rooms.length > 0) {
      try {
        this.loadingHashes = true;
        await this.fetchAndMapHashes();
      } catch (err) {
        this.errors = [
          ...this.errors,
          { ...err, description: this.$t("rooms.erorMessages.noLinks") },
        ];
      } finally {
        this.loadingHashes = false;
      }
    } else {
      this.errors = [
        ...this.errors,
        {
          message: "Not found",
          description: this.$t("rooms.erorMessages.noReviews"),
        },
      ];
    }
  },
};
</script>
